module.exports = __webpack_public_path__ + "assets/images/megaphone-emerald.svg?4fe66bfb8bb1abb210e37422e0f19b33";


//////////////////
// WEBPACK FOOTER
// ./_source/images/icons/sessions/megaphone-emerald.svg
// module id = 369
// module chunks = 0